module.exports = __webpack_public_path__ + "700d6b6cb7cb12ebdd0f09974afd5e49.pdf";